export enum QuestionStyle {
  RadioBoxes,
  RadioCards
}
